class DashboardService {
  createDashboards() {
    console.info("DashboardService: override to create dashboards");
  }
}

export default DashboardService;
